import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
export default () => (_jsx(Typography, { sx: { color: 'text.secondary' }, children: "Course Level Options" }));
//# sourceMappingURL=LevelOptions.js.map